module.exports = __webpack_public_path__ + "img/stats_mobile_fr.ae341b9.webp";